export default "__VITE_ASSET__rgrD6T0G__"